import { useState, useEffect, useCallback } from "react";
import { Sparkles, RefreshCw } from "lucide-react";
import { useApi, errMsg } from "../lib/api";
import { Markdown } from "./Markdown";

export const AiSummary = ({ vid, month }) => {
  const api = useApi();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(async (refresh) => {
    setBusy(true); setErr(null);
    try { setData((await api.get(`/assistant/contractor/${vid}/summary`, { params: { month, refresh: refresh || undefined } })).data); }
    catch (e) { setErr(errMsg(e)); }
    setBusy(false);
  }, [api, vid, month]);
  useEffect(() => { setData(null); load(false); }, [load]);
  return (
    <div className="c-surface p-5 mt-4 border-l-2 border-l-[#00E599]" data-testid="ai-summary">
      <div className="flex items-center justify-between gap-3 mb-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-white"><Sparkles size={15} className="text-[#00E599]" />AI risk summary · {month}</div>
        <button onClick={() => load(true)} disabled={busy} className="inline-flex items-center gap-1 text-xs text-slate-400 hover:text-white disabled:opacity-50" data-testid="ai-summary-refresh">
          <RefreshCw size={12} className={busy ? "animate-spin" : ""} />{busy ? "Writing…" : "Refresh"}</button>
      </div>
      {err && <p className="text-sm text-red-400" data-testid="ai-summary-error">{err}</p>}
      {!data && !err && <p className="text-xs text-slate-500" data-testid="ai-summary-loading">Claude is reading this contractor's filings, holds and workers…</p>}
      {data && <><Markdown text={data.summary} testid="ai-summary-text" />
        <p className="text-[11px] text-slate-500 mt-3">Written by AI from comply369 data on {new Date(data.generated_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}. Check before acting.</p></>}
    </div>);
};
